const flatsList = document.querySelector('.flatsList');
const lockersList = document.querySelector('.lockersList');
const garagesList = document.querySelector('.garagesList');

if (flatsList && flatsList.childNodes.length <= 1) flatsList.parentElement.style.display = 'none';
if (lockersList && lockersList.childNodes.length <= 1)
    lockersList.parentElement.style.display = 'none';
if (garagesList && garagesList.childNodes.length <= 1)
    garagesList.parentElement.style.display = 'none';
